import React, {useEffect} from "react"
import {Layout as AntdLayout} from "antd"
import {createUseStyles} from "react-jss"
import {useLocation} from "react-router-dom"
import Header, {ListProps} from "./header/Header"
import {ConfigProviderProps} from "antd/es/config-provider"
import {getNotificationAccess} from "../utils/cookies"
import Announcement from "../components/Announcement"
import Button from "../components/Button"

const {Content} = AntdLayout

export const globalStyles: ConfigProviderProps["theme"] = {
  token: {
    colorPrimary: "#006f4c",
    colorPrimaryActive: "rgba(0, 111, 76, .2)",
    colorPrimaryHover: "#004f36",
    colorText: "rgba(27, 27, 27, 1)",
    colorLink: "#006f4c",
    colorTextSecondary: "rgba(0, 0, 0, 0.36)",
    colorBorderBg: "#E1ECFC",
    colorPrimaryBg: "#EDF4FD",
    fontSizeHeading1: 16,
    fontSize: 14,
    fontSizeSM: 12,
    colorBgLayout: "#e3e4e4",
    colorBorder: "#e3e4e4",
    red: "rgba(239, 58, 68, 1)",
    colorError: "rgba(239, 58, 68, 1)",
    colorErrorActive: "rgba(239, 58, 68, .2)",
    orange: "#ffc428",
    borderRadiusLG: 20,
    borderRadius: 15,
    borderRadiusSM: 10
  },
  components: {
    Layout: {
      colorBgLayout: "#FFF",
      colorBgContainer: "#FFF"
    },
    Radio: {
      colorPrimary: "#ff2837"
    },
    Select: {
      colorFillSecondary: "#f1d5ab"
    },
    Table: {
      headerBg: "rgba(255, 255, 255, 1)",
      headerSplitColor: "transparent",
      rowHoverBg: "rgba(251, 252, 255, 1)",
      borderColor: "rgba(219, 228, 242, 1)",
      colorBorder: "rgba(219, 228, 242, 1)",
      headerColor: "rgba(54, 77, 104, 1)"
    }
  }
}

const useStyles = createUseStyles({
  layout: {
    background: "#ffffff"
  },
  content: {
    margin: "0",
    padding: 24,
    minHeight: 280
  },
  annoucement: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: 12
  },
  "@media (min-width: 1200px)": {
    content: {
      margin: "0",
      padding: 24,
      minHeight: 280
    }
  }
})

interface LayoutProps {
  children?: React.ReactNode
}

const Layout: React.FC<LayoutProps> = ({children}) => {
  const classes = useStyles()
  const location = useLocation()
  const isNotificationAllowed = getNotificationAccess()

  const list: ListProps[] = [
    {
      title: "Главная",
      link: "/"
    }
  ]

  useEffect(() => {
    document.body.scrollTop = 0
    document.documentElement.scrollTop = 0
  }, [location])

  return (
    <AntdLayout className={classes.layout}>
      {isNotificationAllowed !== "granted" ? (
        <Announcement
          message={
            <div className={classes.annoucement}>
              У вас отключены уведомления! Пожалуйста, включите уведрмоения в
              настройках, чтобы получить уведомления о новых запросах!
              <Button
                href={
                  "https://support.google.com/chrome/answer/3220216?hl=ru&co=GENIE.Platform%3DDesktop"
                }
                target={"_blank"}
              >
                Как включить уведомления?
              </Button>
            </div>
          }
        />
      ) : null}
      <Header title={"Bellissimo Stream"} list={list} />
      <Content className={classes.content}>{children}</Content>
    </AntdLayout>
  )
}

export default Layout
